<template>
  <v-container>
    <sub-navigation-obchody></sub-navigation-obchody>
    <v-layout row wrap>
      <v-flex xs12>
        <v-flex xs12 class="ml-2 mb-2">
          <strong>Obchody a provize za období {{rok}} / {{mesic}}</strong>
        </v-flex>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-0 mb-30"
          :loading="loadingTable"
          :pagination.sync="pagination"
          :total-items="pagination.totalItems"
          :rows-per-page-items="[25, 50, 100, 200]"
        >
          <template v-slot:items="props">
            <td>{{ props.item.datum | formatSimpleDate }}</td>
            <td>
              <span v-if="props.item.klient != null">
                {{ props.item.klient.nazev_osoby }}
              </span>
              <span v-else>
                --
              </span>
            </td>
            <td><span v-if="props.item.podrizeny_pracovnik">{{ props.item.obchodnik.nazev_osoby }}</span><span v-else>--</span></td>
            <td>
              <span v-if="props.item.ucel_platby=='sporici'">Postupný nákup</span>
              <span v-else-if="props.item.ucel_platby=='sporeni'">Postupný nákup</span>
              <span v-else-if="props.item.ucel_platby=='jednorazovy_nakup'">Jednorázový nákup</span>
            </td>
            <td class="text-xs-right">{{ props.item.objem_obchodu| formatMoney }} Kč</td>
            <td class="text-xs-right">{{ props.item.kredity| formatMoney }} kr.</td>
            <td class="text-xs-right">{{ props.item.hodnota_kreditu| formatMoneyInt }} Kč</td>
            <td class="text-xs-right">{{ props.item.castka| formatMoney }} Kč</td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        loading: true,
        loadingTable: false,
        search: "",
        headers: [
          { text: 'Datum', value: 'datum', sortable: false },
          { text: 'Klient', value: 'klient', sortable: false },
          { text: 'Podřízený spolupracovník', value: 'podrizeny_pracovnik', sortable: false },
          { text: 'Typ obchodu', value: 'ucel_platby', sortable: false, align: 'left' },
          { text: 'Objem obchodu', value: 'castka', sortable: false, align: 'right' },
          { text: 'Kredity', value: 'kredity', sortable: false, align: 'right' },
          { text: 'Hodnota kreditu', value: 'hodnota_kreditu', sortable: false, align: 'right' },
          { text: 'Provize', value: 'castka', sortable: false, align: 'right' }
        ],
        items: [],
        nezauctovane: null,
        zauctovane: null,
        zauctovane_obdobi: [],
        timeout: null,
        counter: 0,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 25,
          sortBy: "id",
          totalItems: 0,
          pages: 0
        },
        totalItems: 0
      }
    },
    props: {
      rok: String,
      mesic: String
    },
    watch: {
      pagination: {
    		handler: function(newValue) {
          if (!this.loadingTable)
    			   this.load();
    		},
    		deep: true
    	},
    },
    mounted () {
      if (window.$user.tipar) {
        this.headers[2].text = "Obchodník";
      }
      this.load();
    },
    methods: {
      load (f) {
        this.counter++;
        this.loadingTable = true;
        this.items = [];
        window.API.post("obchody/provize/zuctovane/search", {
          pagination: this.pagination,
          s: this.search,
          echo: this.counter,
          rok: this.rok,
          mesic: this.mesic
        }).then(function(body) {
          if (this.counter != body.echo)
            return;
          this.items = body.data;
          this.pagination.sortBy = body.sort.sortBy;
          this.pagination.descending = body.sort.descending;
          this.pagination.page = body.sort.page;
          this.pagination.rowsPerPage = body.sort.rowsPerPage;
          this.totalItems = body.sort.totalItems;
          this.pagination.pages = body.sort.pages;
          this.loading = false;
          this.loadingTable = false;
          if (typeof f === "function")
            f();
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      detailClick (v) {

      }
    }
  }
</script>
